exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3Vl8n{padding:32px 16px;padding:2rem 1rem}._3Vl8n p:first-child{margin-top:0}@media screen and (min-width:768px){._3Vl8n{padding-top:2rem}}@media screen and (min-width:992px){._3Vl8n{padding-top:3rem}}.a7U9n{background-color:#f4f4ec}", ""]);

// exports
exports.locals = {
	"root": "_3Vl8n",
	"inverse": "a7U9n"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":{"discardComments":{"removeAll":true}}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Page/PageSection.css
// module id = 532
// module chunks = 0 1 2 3 4